export const name = "ST_GEOGFROMGEOJSON";
export const summary = `Converts a \`STRING\` GeoJSON geometry value into a \`GEOGRAPHY\` value.`;
export const reference = `
## ST_GEOGFROMGEOJSON

Converts a \`STRING\` GeoJSON geometry value into a \`GEOGRAPHY\` value.

\`\`\`
ST_GEOGFROMGEOJSON(
  geojson_string
  [, make_valid => constant_expression]
)
\`\`\`

### Description

Returns a \`GEOGRAPHY\` value that corresponds to the input GeoJSON representation.

\`ST_GEOGFROMGEOJSON\` accepts input that's RFC 7946compliant.

If the named argument \`make_valid\` is set to \`TRUE\`, the function attempts to repair polygons that don't conform to Open Geospatial Consortiumsemantics.

A GoogleSQL \`GEOGRAPHY\` has spherical geodesic edges, whereas a GeoJSON \`Geometry\` object explicitly has planar edges. To convert between these two types of edges, GoogleSQL adds additional points to the line where necessary so that the resulting sequence of edges remains within 10 meters of the original edge.

See \`ST_ASGEOJSON\` to format a\`GEOGRAPHY\` as GeoJSON.


### Constraints

The JSON input is subject to the following constraints:

- \`ST_GEOGFROMGEOJSON\` only accepts JSON geometry fragments and can't be used to ingest a whole JSON document.
- The input JSON fragment must consist of a GeoJSON geometry type, which includes \`Point\`, \`MultiPoint\`, \`LineString\`, \`MultiLineString\`, \`Polygon\`,\`MultiPolygon\`, and \`GeometryCollection\`. Any other GeoJSON type such as\`Feature\` or \`FeatureCollection\` will result in an error.
- A position in the \`coordinates\` member of a GeoJSON geometry type must consist of exactly two elements. The first is the longitude and the second is the latitude. Therefore, \`ST_GEOGFROMGEOJSON\` doesn't support the optional third element for a position in the \`coordinates\` member.


### Return type

\`GEOGRAPHY\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
